// extracted by mini-css-extract-plugin
var _1 = "CustomerTransferTable-module__action-button-container";
var _2 = "CustomerTransferTable-module__gold-row";
var _3 = "CustomerTransferTable-module__show-serial-no";
var _4 = "CustomerTransferTable-module__slot-left";
export { _1 as "action-button-container", _2 as "gold-row", _3 as "show-serial-no", _4 as "slot-left" }
